// The scoreboard of the team games, as the phones and the panel keep it: both scores and the
// timer of the game on stage

export const TEAMS = [
  { id: 'red', label: 'Rojo' },
  { id: 'white', label: 'Blanco' },
];
export const POINTS = [10, 15, 20, 25, 30]; // what the panel can give a team
export const MAX_TIMER_MINUTES = 99; // the clock shows MM:SS

export const EMPTY_SCOREBOARD = { red: 0, white: 0, version: 0, timer: null };

// Every change reaches the room as an `app:SCORE` event with the whole scoreboard, as text.
// `live` tells it from one that was only loaded: the score that changed stands out a moment
export const scoreboardFromEvent = ({ attributes }) => ({
  red: Number(attributes.red) || 0,
  white: Number(attributes.white) || 0,
  version: Number(attributes.version) || 0,
  timer: attributes.timerId
    ? { id: attributes.timerId, remainingMs: Number(attributes.remainingMs) || 0, durationMs: Number(attributes.durationMs) || 0 }
    : null,
  live: true,
});

/**
 * The scoreboard after hearing `incoming` (from the room, /history or the panel API). Every
 * change bumps the version, so the same one again, or an older one that arrives late, never
 * wins. The timer comes as the time left: the device counts down from the moment it first
 * hears about that timer, by its own clock, so a phone with the wrong time shows the same
 * as the rest; hearing about the same timer again (a team got points, the chat reconnected)
 * never moves it.
 */
export const withScoreboard = (current, incoming, now = Date.now()) => {
  if (!incoming || incoming.version <= current.version) return current;
  const { red, white, version, timer } = incoming;
  const anchored = timer && current.timer?.id === timer.id ? current.timer : null;
  return {
    red,
    white,
    version,
    timer: timer ? anchored || { id: timer.id, endsAt: now + timer.remainingMs, durationMs: timer.durationMs } : null,
    live: Boolean(incoming.live),
  };
};

// Whole seconds left on the timer: 299.2 s still reads 05:00, and it reads 00:00 only when it is over
export const secondsLeft = (timer, now = Date.now()) => (timer ? Math.max(0, Math.ceil((timer.endsAt - now) / 1000)) : 0);

// 7 -> "07": the scoreboard never shows fewer than two digits
export const twoDigits = (number) => String(number).padStart(2, '0');

// 272 -> "04:32"
export const clock = (seconds) => `${twoDigits(Math.floor(seconds / 60))}:${twoDigits(seconds % 60)}`;
